export const quotes = {
  articles: [
    'Freedom is Hammered Out on the Anvil of Debate',
    'Debate is not won by suppression, but with the better argument',
    'Starting Your Article Debate...'
  ]
};
